/**
 * <featured-collection-v2-filter> — page-level filter bar for featured-collection-v2 sliders.
 *
 * Buttons carry data-group (the slide data-* key, e.g. "sport"/"gender") and data-value.
 * Clicking sets the active button within its group and broadcasts the full filter state as a
 * `fcv2:filter` document event. Each <featured-collection-v2> listens and hides/shows its slides.
 * Dimensions are AND-combined; an empty value ("All") clears the constraint for that group.
 */
(function () {
  class FeaturedCollectionV2Filter extends HTMLElement {
    connectedCallback() {
      this._state = {};
      this._ac = new AbortController();

      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.fcv2-filter__btn');
        if (!btn || !this.contains(btn)) return;

        const group = btn.dataset.group;
        this._state[group] = btn.dataset.value || '';

        this.querySelectorAll('.fcv2-filter__btn[data-group="' + group + '"]').forEach((b) => {
          b.classList.toggle('is-active', b === btn);
        });

        document.dispatchEvent(new CustomEvent('fcv2:filter', { detail: { filters: this._state } }));
      }, { signal: this._ac.signal });
    }

    disconnectedCallback() {
      if (this._ac) this._ac.abort();
    }
  }

  if (!customElements.get('featured-collection-v2-filter')) {
    customElements.define('featured-collection-v2-filter', FeaturedCollectionV2Filter);
  }
})();
